module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/word.33064f82.svg";